module.exports = __webpack_public_path__ + "static/media/3DPPA14.b4d18640.jpg";